import { createContext, useContext, useState, useCallback } from 'react';
import { CheckCircle, XCircle } from 'lucide-react';

// Same global toast system as the driver app — call useToast() from any
// component to show a success/error popup, no prop drilling needed.
const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((type, message) => {
    setToast({ type, message });
    setTimeout(() => setToast(null), 3000);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {toast && (
        <div style={styles.container}>
          <div
            style={{
              ...styles.toast,
              backgroundColor: toast.type === 'success' ? '#065f46' : '#991b1b',
            }}
          >
            {toast.type === 'success' ? (
              <CheckCircle size={18} color="white" style={{ flexShrink: 0 }} />
            ) : (
              <XCircle size={18} color="white" style={{ flexShrink: 0 }} />
            )}
            <span style={styles.message}>{toast.message}</span>
          </div>
        </div>
      )}
    </ToastContext.Provider>
  );
}

export function useToast() {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
}

const styles = {
  container: {
    position: 'fixed',
    top: 16,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'center',
    zIndex: 200,
    pointerEvents: 'none',
  },
  toast: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '12px 16px',
    borderRadius: 10,
    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
    maxWidth: 380,
    width: '90%',
  },
  message: {
    color: 'white',
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1.4,
  },
};
